import VisualizarAtendimento from '../components/VisualizarAtendimento.vue'
import FilaAtendimento from '../components/FilaAtendimento.vue'

let routes = {
    path: '/paciente',
    component: resolve => require(['../components/layout/HeaderAndLeftNavBar.vue'], resolve),
    children: [
        {
            path: '/visualizar-atendimento/:id?',
            name: 'VisualizarAtendimento',
            component: VisualizarAtendimento
        },
        {
            path: '/fila-atendimento/:id?',
            name: 'FilaAtendimento',
            component: FilaAtendimento
        },
    ]
};


export default routes


// WEBPACK FOOTER //
// ./src/router/visualizar-atendimento.js